(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rove6-accessories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:cart:lines-update', (event) => {
    const form = event.target instanceof Element ? event.target.closest('form.r6-accessory-form') : null;
    if (!form || event.action !== 'add' || !event.promise || typeof event.promise.then !== 'function') return;
    const button = form.querySelector('[data-rove6-add]');
    const card = form.closest('.r6-accessory-card__body');
    const label = button?.querySelector('[data-button-label]');
    const status = card?.querySelector('.r6-accessory-status');
    if (!button || !label || !status) return;
    const operation = {};
    button.rapidAccessoryOperation = operation;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-added', 'has-error');
    button.classList.add('is-loading');
    label.textContent = button.dataset.addingLabel;
    status.textContent = '';
    const restore = (delay, clearStatus) => {
      window.setTimeout(() => {
        if (!button.isConnected || button.rapidAccessoryOperation !== operation) return;
        button.classList.remove('is-added', 'has-error');
        button.disabled = false;
        label.textContent = button.dataset.defaultLabel;
        if (clearStatus) status.textContent = '';
      }, delay);
    };
    event.promise.then(() => {
      if (!button.isConnected || button.rapidAccessoryOperation !== operation) return;
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.removeAttribute('aria-busy');
      label.textContent = button.dataset.addedLabel;
      status.textContent = button.dataset.addedAnnouncement;
      restore(2200, true);
    }, (error) => {
      if (!button.isConnected || button.rapidAccessoryOperation !== operation) return;
      button.classList.remove('is-loading');
      button.classList.add('has-error');
      button.removeAttribute('aria-busy');
      button.disabled = false;
      label.textContent = button.dataset.errorLabel;
      status.textContent = error?.message || button.dataset.errorLabel;
      restore(3200, false);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["universal-product-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rapid-universal-product-video')) {
    customElements.define('rapid-universal-product-video', class extends HTMLElement {
      embedFromUrl(raw) {
        try {
          const url = new URL(raw);
          if (!['http:', 'https:'].includes(url.protocol)) return '';
          const host = url.hostname.replace(/^www\./, '');
          let id = '';
          if (host === 'youtu.be') id = url.pathname.split('/').filter(Boolean)[0] || '';
          if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
            if (url.pathname === '/watch') id = url.searchParams.get('v') || '';
            if (url.pathname.indexOf('/embed/') === 0) id = url.pathname.split('/')[2] || '';
          }
          return /^[A-Za-z0-9_-]{6,}$/.test(id) ? 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?enablejsapi=1&playsinline=1' : '';
        } catch (error) {
          return '';
        }
      }
      connectedCallback() {
        if (this.onPlayerMessage) return;
        const heading = this.querySelector('[data-video-heading]');
        const eyebrow = this.querySelector('[data-video-eyebrow]');
        const copy = this.querySelector('[data-video-copy]');
        const slot = this.querySelector('[data-video-slot]');
        const embedUrl = this.embedFromUrl(this.dataset.metafieldVideoUrl);
        if (!embedUrl || !heading || !heading.textContent.trim() || !eyebrow || !eyebrow.textContent.trim() || !copy || !copy.textContent.trim() || !slot) return;
        let frame = slot.querySelector('iframe');
        if (!frame) {
          frame = document.createElement('iframe');
          frame.id = this.dataset.frameId;
          frame.src = embedUrl;
          frame.title = heading.textContent.trim();
          frame.loading = 'lazy';
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          frame.allowFullscreen = true;
          frame.addEventListener('load', () => {
            if (!frame.contentWindow) return;
            frame.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: frame.id, channel: 'widget' }), 'https://www.youtube.com');
            frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'addEventListener', args: ['onStateChange'], id: frame.id }), 'https://www.youtube.com');
          }, { once:true });
          slot.appendChild(frame);
        }
        this.onPlayerMessage = event => {
          if (event.source !== frame.contentWindow || !/^https:\/\/www\.youtube(?:-nocookie)?\.com$/.test(event.origin)) return;
          let message;
          try { message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch (error) { return; }
          if (message && message.event === 'onStateChange' && Number(message.info) === 1) this.classList.add('is-playing');
        };
        window.addEventListener('message', this.onPlayerMessage);
        this.hidden = false;
        this.removeAttribute('aria-hidden');
      }
      disconnectedCallback() {
        if (this.onPlayerMessage) window.removeEventListener('message', this.onPlayerMessage);
        this.onPlayerMessage = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
